export default __webpack_public_path__ + "static/media/arrow-down.d48242e0.svg";